import i18n from "../../../utils/ChrI18n";
import { pick } from "../../../utils/CoreExtensions/ObjectExtensions";

export const filterStatus = {
  SAVED: "saved",
  UNSAVED: "unsaved"
};

export const actionSetType = {
  TEXT: "text",
  BUTTON: "button"
};

export const actionSetPosition = {
  STATIC: "static",
  DYNAMIC: "dynamic"
};

export const filterWrapperDropdownAlignment = {
  LEFT: 'left',
  RIGHT: 'right'
}

export const actionStatus = {
  ENABLED: "enabled",
  DISABLED: "disabled"
}

export const actions = {
  CANCEL: "cancel",
  APPLY: "apply",
  CLEAR: "clear"
};

export const defaultActions = [actions.CANCEL, actions.APPLY];

export const actionsConfig = (props) => {
  const configs = {
    [actions.CANCEL]: {
      label: i18n.t("display_string.Cancel"),
      callback: props.onCancelHandler,
      state: props.actionState?.cancel
    },
    [actions.APPLY]: {
      label: i18n.t("display_string.Apply"),
      callback: props.onSubmitHandler,
      state: props.actionState?.submit
    },
    [actions.CLEAR]: {
      label: i18n.t("display_string.Clear"),
      callback: props.onClearHandler,
      state: props.actionState?.clear
    }
  };
  return pick(configs, ...(props.actions && props.actions.length > 0 ? props.actions : defaultActions));
};